export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: 'http //www.17c/ 的正确入口地址是什么？',
    answer: '请直接在浏览器地址栏中输入 http //www.17c/ 即可进入 17c 平台官方首页。请务必确认输入地址的准确性，避免误入仿冒网站。建议将官方地址添加至浏览器收藏夹，方便日常访问。',
  },
  {
    question: '访问 http //www.17c/ 需要什么浏览器？',
    answer: '平台兼容主流浏览器，包括 Google Chrome（推荐）、Microsoft Edge、Apple Safari、Mozilla Firefox 等。为确保最佳体验，建议使用最新版本的浏览器访问。',
  },
  {
    question: '如何注册 17c 平台账号？',
    answer: '访问 http //www.17c/ 首页后，点击右上角"注册"按钮，输入手机号或邮箱地址，设置安全密码，获取验证码后即可完成注册。注册过程通常不超过 2 分钟。',
  },
  {
    question: '忘记登录密码怎么办？',
    answer: '在登录页面点击"忘记密码"，输入注册时绑定的手机号或邮箱，接收验证码后即可重置密码。重置后请使用新密码登录。为了账号安全，建议定期更换密码。',
  },
  {
    question: '17c 平台有哪些核心功能？',
    answer: '17c 平台提供智能数据管理、协同办公平台、智能分析引擎、安全保障体系和开放 API 接口等核心功能模块，为用户提供全方位的数字化服务。',
  },
  {
    question: '平台是否免费使用？',
    answer: '17c 平台提供基础功能的免费使用套餐，用户注册后即可体验核心功能。同时平台也提供高级付费套餐，包含更多专业功能和更高的使用额度。具体费用标准请查阅平台相关页面。',
  },
  {
    question: '移动端可以使用 17c 平台吗？',
    answer: '可以。在手机浏览器的地址栏中输入 http //www.17c/ 即可访问移动端适配版本。平台已针对移动设备进行优化，操作体验流畅便捷。',
  },
  {
    question: '如何联系 17c 平台客服？',
    answer: '您可以通过以下方式联系我们：访问"关于我们"页面获取联系信息、发送邮件至官方客服邮箱、在平台内使用在线客服功能。我们的客服团队工作时间为周一至周五 9:00-18:00。',
  },
  {
    question: '平台数据安全如何保障？',
    answer: '17c 平台采用多层安全防护机制，包括数据加密传输、访问权限控制、操作日志审计等措施。用户数据存储在安全的数据中心，定期进行备份，确保数据安全可靠。',
  },
  {
    question: '如何获取平台最新动态？',
    answer: '您可以关注平台首页的公告栏，或定期访问"平台功能"分类下的最新文章。重要更新和活动信息我们会通过站内信或邮件通知注册用户。',
  },
];